import CardSkeleton from "@/components/Skeleton/CardSkeleton";
import SectionHeading from "@/components/SectionHeading";

const JobPreferencesSkeleton = () => {
  return (
    <>
      <SectionHeading heading="Job Preferences" body="View and manage job preferences" />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <CardSkeleton rows={8} width={100} />
        <div className="flex flex-col gap-4 col-span-2">
          <CardSkeleton rows={8} width={100} />
        </div>
      </div>
    </>
  );
};

export default JobPreferencesSkeleton;
